import React from "react";
import classNames from "classnames";
import { useTranslation } from "react-i18next";

import { Safeguard } from "@scenes/safeguard";
import { useModal } from "@root/client/modal";
import { UseCases } from "@planzone/core";
import { VisibilityWatcher } from "@common/visibilityWatcher";
import { ZoneAvatar } from "@common/zoneAvatar";
import { ArrowIcon } from "./arrowIcon";
import { Props } from "./types";
import styles from "./styles.scss";

function Menu({ zone }: Props) {
  const { pushView } = useModal();
  const { t } = useTranslation();

  return (
    <VisibilityWatcher>
      {(isVisible, show, hide) => (
        <div
          className={classNames(styles.menu, { [styles.open]: isVisible })}
          onClick={isVisible ? hide : show}
        >
          <div className={styles.input}>
            <div className={styles.avatar}>
              <ZoneAvatar {...zone} />
            </div>
            <span className={styles.name}>{zone.name}</span>
            <ArrowIcon className={styles.toggleArrow} />
          </div>
          {isVisible && (
            <div className={styles.list}>
              <p
                className={styles.item}
                onClick={() =>
                  pushView({
                    data: zone,
                    key: UseCases.editZone,
                  })
                }
              >
                {t("zonePage.menu.details")}
              </p>
              <Safeguard useCases={[UseCases.removeZone]}>
                {({ canRemoveZone }) =>
                  canRemoveZone && (
                    <p
                      className={classNames(styles.item, styles.dangerous)}
                      onClick={() =>
                        pushView({
                          data: zone,
                          key: UseCases.removeZone,
                        })
                      }
                    >
                      {t("zonePage.menu.remove")}
                    </p>
                  )
                }
              </Safeguard>
            </div>
          )}
        </div>
      )}
    </VisibilityWatcher>
  );
}

export { Menu };
